import { observer } from "mobx-react";
import React, { useContext } from "react";
import { FiArrowLeft, FiChevronRight } from "react-icons/fi";
import { useStores } from "../../../../stores";
import { LocationPickerContext, LocationSource, ModalType } from "./context";

export const LocationPicker = observer(() => {
  const { coverageAreaStore, cartStore } = useStores();
  const { setModalType, onClose } = useContext(LocationPickerContext);

  return (
    <>
      <div className="flex items-center mb-4">
        {coverageAreaStore?.selectedCoverageArea && (
          <FiArrowLeft
            onClick={onClose}
            className="text-heading5 cursor-pointer"
            id="location-picker-dialog-back-btn"
            data-testid="location-picker-dialog-back-btn"
          />
        )}
        <div className="ml-2 text-label-xl font-bold">
          Pilih Lokasi Pengiriman
        </div>
      </div>

      <div
        onClick={() => setModalType(ModalType.cityPicker)}
        className="bg-white hover:bg-gray-50 rounded-lg p-4 flex items-center justify-between shadow max-w-full cursor-pointer mb-4"
        id="location-picker-dialog-city-btn"
        data-testid="location-picker-dialog-city-btn"
      >
        <div>
          <span className="block font-bold text-label-lg">
            Pilih Kota & Kecamatan
          </span>
          {coverageAreaStore?.selectedCoverageArea?.locationSource ===
            LocationSource.dropdown &&
          coverageAreaStore?.selectedCoverageArea ? (
            <span className="text-primary text-label-sm mobile-m:text-label-sm pt-1">
              {coverageAreaStore?.selectedCity?.name} -{" "}
              {coverageAreaStore?.selectedDistrict?.name}
            </span>
          ) : (
            <span className="text-label-sm pt-1">
              Sesuai tujuan pengirimanmu
            </span>
          )}
        </div>
        <FiChevronRight className="text-primary text-heading5 shrink-0" />
      </div>

      <div
        onClick={() => setModalType(ModalType.mapPicker)}
        className="bg-white hover:bg-gray-50 rounded-lg p-4 flex items-center justify-between shadow max-w-full cursor-pointer mb-1"
        id="location-picker-dialog-map-btn"
        data-testid="location-picker-dialog-map-btn"
      >
        <div>
          <span className="block font-bold text-label-lg">
            Mau Lebih Akurat
          </span>
          {coverageAreaStore?.selectedCoverageArea?.locationSource ===
            LocationSource.map &&
          cartStore?.savedCheckoutData?.customerAddress ? (
            <span className="text-primary line-clamp-1 text-label-sm pt-1">
              {cartStore?.savedCheckoutData?.customerAddress?.address}
            </span>
          ) : (
            <span className="text-label-sm mobile-m:text-label-md pt-1">
              Masukkan alamat & titik lokasi
            </span>
          )}
        </div>
        <FiChevronRight className="text-primary text-heading5 shrink-0" />
      </div>
    </>
  );
});
